<template>
    <div>
        <v-tabs v-model="report" background-color="white">
            <v-tab v-if="roles.read_report_idea"> Idea </v-tab>
            <v-tab v-if="roles.read_report_kpi"> KPI </v-tab>
        </v-tabs>

        <v-tabs-items v-model="report">
            <!-- Idea -->
            <v-tab-item v-if="roles.read_report_idea">
                <v-card>
                    <IdeaReport />
                </v-card>
            </v-tab-item>

            <!-- KPI -->
            <v-tab-item v-if="roles.read_report_kpi">
                <v-card>
                    <KpiReport />
                </v-card>
            </v-tab-item>
         </v-tabs-items>
    </div>
</template>

<script>
    import IdeaReport from "./c-idea-report.vue"
    import KpiReport from "./c-kpi-report.vue"
    export default {
        name: "ReportContainer",

        components:{
            IdeaReport,
            KpiReport
        },

        data:() => ({
            report:'',
            roles:[],
        }),

        async mounted(){
            this.roles = await this.$cookies.get("idea");
        }
    }
</script>

<style lang="scss" scoped>

</style>